export default "__VITE_ASSET__C$XuG19S__"